(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calcolatore-pizzeria"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var GROUPS = ['daysOpen','avgTicket','weakDays','emptyRate','adsInvest','adsBudget','socialMgr','adsTracking','contactCollect','contactInvite','weakTactics','priorityGoal'];
  var DEFAULTS = {seats:60,daysOpen:6,avgTicket:18,weakDays:3,emptyRate:0.6,adsInvest:'sometimes',adsBudget:300,socialMgr:'io',adsTracking:'likes',contactCollect:'none',contactInvite:'never',weakTactics:'discounts',priorityGoal:'fill_weak'};
  var SAMPLE = {seats:75,daysOpen:6,avgTicket:19,weakDays:3,emptyRate:0.6,adsInvest:'sometimes',adsBudget:300,socialMgr:'io',adsTracking:'likes',contactCollect:'none',contactInvite:'never',weakTactics:'discounts',priorityGoal:'fill_weak'};

  function assign(t, src) { for (var k in src) { if (Object.prototype.hasOwnProperty.call(src, k)) t[k] = src[k]; } return t; }
  function clean(v) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim(); }
  function fill(tpl, map) { return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }
  function uid() {
    try { if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID(); } catch (e) {}
    return 'ysd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function utm() {
    var out = {};
    try {
      var p = new URLSearchParams(window.location.search);
      ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid'].forEach(function (k) { var v = p.get(k); if (v) out[k] = v; });
    } catch (e) {}
    return out;
  }

  function init(root) {
    if (!root || root.getAttribute('data-ysd-ready') === '1') return;
    root.setAttribute('data-ysd-ready', '1');

    var C = {};
    try { C = JSON.parse(root.querySelector('[data-ysd-config]').textContent); } catch (e) { C = {}; }
    var T = C.texts || {};
    var cur = C.currency || '€';

    function q(sel) { return root.querySelector(sel); }
    function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function setText(sel, txt) { var el = q(sel); if (el) el.textContent = txt; }

    var state = assign({ step: 1, total: 5, monthlyLost: 0, monthlyReclaim: 0, annualReclaim: 0, recoveryRate: 0.35, lead: null }, DEFAULTS);
    var leadId = null, slot = null, timers = [], busy = false;

    var screens = {};
    qa('[data-screen]').forEach(function (el) { screens[el.getAttribute('data-screen')] = el; });
    var slider = q('[data-seats-input]');
    var seatsOut = q('[data-seats-out]');
    var ticketInput = q('[data-ticket-input]');
    var budgetBox = q('[data-budget-box]');
    var form = q('[data-lead-form]');

    function money(n) { return cur + ' ' + Math.round(n).toLocaleString('it-IT'); }
    function scrollToRoot() {
      var y = root.getBoundingClientRect().top + window.pageYOffset - (parseInt(C.scrollOffset, 10) || 0);
      if (Math.abs(window.pageYOffset - y) > 8) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
    function show(name, noScroll) {
      Object.keys(screens).forEach(function (k) { screens[k].classList.toggle('is-hidden', k !== name); });
      if (!noScroll) scrollToRoot();
    }
    function clearTimers() { timers.forEach(clearTimeout); timers = []; }

    /* ---------- stato & UI ---------- */
    function setSeats(v) {
      v = parseInt(v, 10);
      if (isNaN(v)) v = DEFAULTS.seats;
      v = Math.min(250, Math.max(20, v));
      state.seats = v;
      if (slider) slider.value = v;
      if (seatsOut) seatsOut.textContent = v;
    }
    function syncGroups() {
      qa('[data-group]').forEach(function (b) {
        var on = String(state[b.getAttribute('data-group')]) === b.getAttribute('data-value');
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (budgetBox) budgetBox.classList.toggle('is-hidden', state.adsInvest === 'never');
    }
    function sync() {
      syncGroups();
      if (ticketInput) ticketInput.value = state.avgTicket;
      setSeats(state.seats);
    }
    function choose(btn) {
      var g = btn.getAttribute('data-group');
      var v = btn.getAttribute('data-value');
      state[g] = btn.hasAttribute('data-num') ? parseFloat(v) : v;
      if (g === 'adsInvest') {
        if (v === 'never') state.adsBudget = 0;
        else if (!state.adsBudget) state.adsBudget = DEFAULTS.adsBudget;
      }
      sync();
    }

    /* ---------- wizard ---------- */
    function renderStep() {
      var st = state.step, tot = state.total, pct = Math.round(st / tot * 100);
      var titles = T.stepTitles || [];
      setText('[data-step-badge]', fill(T.stepTpl || '[n]/[tot]', { n: st, tot: tot }));
      setText('[data-step-title]', clean(titles[st - 1]));
      setText('[data-step-pct]', fill(T.pctTpl || '[pct]%', { pct: pct }));
      var bar = q('[data-step-bar]'); if (bar) bar.style.width = pct + '%';
      qa('[data-step]').forEach(function (p) { p.classList.toggle('is-hidden', parseInt(p.getAttribute('data-step'), 10) !== st); });
      qa('[data-dot]').forEach(function (d) {
        var i = parseInt(d.getAttribute('data-dot'), 10);
        d.classList.toggle('is-current', i === st);
        d.classList.toggle('is-done', i < st);
      });
      var back = q('[data-back]'); if (back) back.disabled = st === 1;
      var nx = q('[data-next]'), cl = q('[data-calc]');
      if (nx) nx.classList.toggle('is-hidden', st === tot);
      if (cl) cl.classList.toggle('is-hidden', st !== tot);
    }
    function startWizard() { clearTimers(); state.step = 1; renderStep(); show('wizard'); }

    /* ---------- calcolo ---------- */
    function compute() {
      var pct = Math.min(100, Math.max(0, parseFloat(C.recoveryPct) || 35)) / 100;
      var weekly = state.weakDays * (state.seats * state.emptyRate) * state.avgTicket;
      var lost = Math.round(weekly * 4.2);
      var rec = Math.round(lost * pct);
      state.recoveryRate = pct;
      state.monthlyLost = lost;
      state.monthlyReclaim = rec;
      state.annualReclaim = rec * 12;
    }
    function markDone(it) {
      if (!it) return;
      it.classList.add('is-done');
      var ic = it.querySelector('.ysd-icon'); if (ic) ic.textContent = 'check_circle';
    }
    function runCalc() {
      clearTimers();
      show('loading');
      var bar = q('[data-load-bar]');
      var items = qa('[data-load-item]');
      items.forEach(function (it) { it.classList.remove('is-done'); var ic = it.querySelector('.ysd-icon'); if (ic) ic.textContent = 'radio_button_unchecked'; });
      if (bar) bar.style.width = '25%';
      setText('[data-load-stage]', clean((T.loads || [])[0]));
      timers.push(setTimeout(function () { if (bar) bar.style.width = '65%'; setText('[data-load-stage]', clean((T.loads || [])[1])); markDone(items[0]); }, 500));
      timers.push(setTimeout(function () { if (bar) bar.style.width = '95%'; setText('[data-load-stage]', clean((T.loads || [])[2])); markDone(items[1]); }, 1000));
      timers.push(setTimeout(renderResults, 1500));
    }
    function renderBars() {
      var w = Math.max(15, Math.round((1 - state.emptyRate) * 100));
      var t = Math.min(85, w + 35);
      var curH = [w - 5, w, w + 5, Math.min(75, w + 20)];
      var tgtH = [t - 5, t, t + 5, Math.min(90, t + 10)];
      for (var i = 0; i < 4; i++) {
        var c = q('[data-bar="cur-' + i + '"]'), g = q('[data-bar="tgt-' + i + '"]');
        if (c) c.style.height = Math.max(5, curH[i]) + '%';
        if (g) g.style.height = tgtH[i] + '%';
      }
    }
    function setAudit(n, o) {
      if (!o) return;
      ['tag', 'title', 'desc', 'action'].forEach(function (k) {
        if (o[k]) setText('[data-audit="' + n + '-' + k + '"]', fill(o[k], { budget: state.adsBudget, currency: cur }));
      });
    }
    function renderAudit() {
      var A = T.audit || {};
      setAudit('f1', state.contactCollect === 'none' ? A.f1none : A.f1other);
      if (state.adsTracking === 'likes' || state.adsTracking === 'unsure') setAudit('f2', A.f2likes);
      else if (state.adsInvest === 'never') setAudit('f2', A.f2never);
      else setAudit('f2', A.f2default);
      setAudit('f3', (state.priorityGoal === 'stop_discounts' || state.weakTactics === 'discounts') ? A.f3discounts : A.f3other);
    }
    function renderResults() {
      compute();
      var outs = { seats: state.seats, ticket: state.avgTicket, weak_days: state.weakDays, pct: Math.round(state.recoveryRate * 100) + '%' };
      qa('[data-out]').forEach(function (el) { var k = el.getAttribute('data-out'); if (outs[k] !== undefined) el.textContent = outs[k]; });
      setText('[data-kpi="lost"]', money(state.monthlyLost));
      setText('[data-kpi="reclaim"]', money(state.monthlyReclaim));
      setText('[data-kpi="annual"]', money(state.annualReclaim));
      renderBars();
      renderAudit();
      hideLeadError();
      show('results');
    }

    /* ---------- webhook ---------- */
    function answerLabels() {
      var out = { seats: state.seats };
      GROUPS.forEach(function (g) {
        var b = root.querySelector('[data-group="' + g + '"].is-active');
        out[g] = b ? clean(b.textContent) : (g === 'avgTicket' ? state.avgTicket + ' ' + cur : null);
      });
      return out;
    }
    function auditTexts() {
      var out = {};
      qa('[data-audit]').forEach(function (el) { out[el.getAttribute('data-audit').replace(/-/g, '_')] = clean(el.textContent); });
      return out;
    }
    function payload(eventName) {
      return {
        event: eventName,
        lead_id: leadId,
        submitted_at: new Date().toISOString(),
        inputs: {
          seats: state.seats, days_open: state.daysOpen, avg_ticket: state.avgTicket, weak_days: state.weakDays,
          empty_rate: state.emptyRate, ads_invest: state.adsInvest, ads_budget: state.adsBudget,
          social_manager: state.socialMgr, ads_tracking: state.adsTracking, contact_collect: state.contactCollect,
          contact_invite: state.contactInvite, weak_tactics: state.weakTactics, priority_goal: state.priorityGoal
        },
        answers: answerLabels(),
        results: {
          currency: cur, monthly_lost: state.monthlyLost, monthly_reclaim: state.monthlyReclaim,
          annual_reclaim: state.annualReclaim, recovery_rate: state.recoveryRate
        },
        audit: auditTexts(),
        source: {
          shop: C.shop || null, section_id: C.sectionId || null, page_url: window.location.href,
          page_title: document.title, referrer: document.referrer || null,
          language: navigator.language || null, user_agent: navigator.userAgent, utm: utm()
        }
      };
    }
    function send(data) {
      var url = clean(C.webhookUrl);
      if (!url) return Promise.reject(new Error('no_webhook'));
      var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var to = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (r) {
        clearTimeout(to);
        if (!r.ok) throw new Error('http_' + r.status);
        return r;
      }, function (err) { clearTimeout(to); throw err; });
    }

    /* ---------- form lead ---------- */
    function showLeadError(msg) { var el = q('[data-lead-error]'); if (el) { el.textContent = msg || ''; el.classList.remove('is-hidden'); } }
    function hideLeadError() { var el = q('[data-lead-error]'); if (el) { el.textContent = ''; el.classList.add('is-hidden'); } }
    function setSubmitting(on) {
      var b = q('[data-lead-submit]'); if (b) b.disabled = on;
      setText('[data-lead-submit-text]', on ? (T.sending || '…') : (T.submit || ''));
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        function f(n) { var el = form.querySelector('[name="' + n + '"]'); return el ? clean(el.value) : ''; }
        if (f('company_website')) return;
        var consentEl = form.querySelector('[name="consent"]');
        var lead = { name: f('name'), pizzeria: f('pizzeria'), email: f('email'), phone: f('phone'), consent: !!(consentEl && consentEl.checked) };
        if (!lead.name || !lead.pizzeria || !lead.email || !lead.phone || !lead.consent) { showLeadError(T.errFields); return; }
        leadId = leadId || uid();
        var data = payload('lead_submitted');
        data.lead = lead;
        busy = true; hideLeadError(); setSubmitting(true);
        send(data).then(function () {
          busy = false; setSubmitting(false);
          state.lead = lead;
          resetBooking();
          show('confirm');
        }, function (err) {
          busy = false; setSubmitting(false);
          showLeadError(err && err.message === 'no_webhook' ? T.errNoWebhook : T.errSend);
        });
      });
    }

    /* ---------- prenotazione ---------- */
    function selectSlot(btn) {
      qa('[data-slot]').forEach(function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      slot = btn ? { day: btn.getAttribute('data-day'), time: btn.getAttribute('data-time') } : null;
    }
    function bookingMsg(txt, isErr) {
      var el = q('[data-booking-msg]'); if (!el) return;
      el.textContent = txt || '';
      el.classList.toggle('is-error', !!isErr);
      el.classList.toggle('is-hidden', !txt);
    }
    function bookingBtn(mode) {
      var b = q('[data-booking-btn]'), ic = q('[data-booking-icon]');
      if (!b) return;
      b.disabled = mode !== 'idle';
      b.classList.toggle('is-done', mode === 'done');
      if (ic) ic.textContent = mode === 'sending' ? 'sync' : (mode === 'done' ? 'check' : 'event_available');
      setText('[data-booking-text]', mode === 'sending' ? (T.bookingSending || '') : (mode === 'done' ? (T.bookingDone || '') : (T.bookingBtn || '')));
    }
    function resetBooking() {
      bookingBtn('idle'); bookingMsg('');
      var def = q('[data-slot][data-default]') || q('[data-slot]');
      selectSlot(def);
    }
    function confirmBooking() {
      if (busy) return;
      if (C.bookingUrl) {
        window.open(C.bookingUrl, '_blank', 'noopener');
        if (C.sendBooking) { var d0 = payload('booking_link_opened'); d0.lead = state.lead; send(d0).catch(function () {}); }
        return;
      }
      if (!slot) { bookingMsg(T.bookingNoSlot, true); return; }
      var data = payload('booking_requested');
      data.lead = state.lead;
      data.booking = { day: slot.day, time: slot.time, label: clean(slot.day + ' ' + slot.time) };
      busy = true; bookingMsg(''); bookingBtn('sending');
      (C.sendBooking ? send(data) : Promise.resolve()).then(function () {
        busy = false; bookingBtn('done'); bookingMsg(T.bookingMsg, false);
      }, function () {
        busy = false; bookingBtn('idle'); bookingMsg(T.errSend, true);
      });
    }

    /* ---------- reset ---------- */
    function resetAll() {
      clearTimers();
      assign(state, DEFAULTS);
      state.step = 1; state.lead = null; leadId = null;
      sync(); renderStep();
      if (form) form.reset();
      hideLeadError(); setSubmitting(false); resetBooking();
      show('hero');
    }

    /* ---------- eventi ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var g = t.closest('[data-group]');
      if (g && root.contains(g)) { choose(g); return; }
      var sl = t.closest('[data-slot]');
      if (sl && root.contains(sl)) { selectSlot(sl); bookingMsg(''); return; }
      var a = t.closest('[data-action]');
      if (!a || !root.contains(a)) return;
      switch (a.getAttribute('data-action')) {
        case 'start': startWizard(); break;
        case 'next': if (state.step < state.total) { state.step++; renderStep(); scrollToRoot(); } break;
        case 'prev': if (state.step > 1) { state.step--; renderStep(); scrollToRoot(); } break;
        case 'calc': runCalc(); break;
        case 'edit': state.step = 1; renderStep(); show('wizard'); break;
        case 'reset': resetAll(); break;
        case 'sample': assign(state, SAMPLE); sync(); runCalc(); break;
        case 'quick':
          setSeats(a.getAttribute('data-seats'));
          var tk = parseFloat(a.getAttribute('data-ticket')); if (!isNaN(tk) && tk > 0) state.avgTicket = tk;
          sync(); startWizard(); break;
        case 'seats-minus': setSeats(state.seats - 5); break;
        case 'seats-plus': setSeats(state.seats + 5); break;
        case 'print': window.print(); break;
        case 'confirm-booking': confirmBooking(); break;
      }
    });
    if (slider) slider.addEventListener('input', function () { setSeats(slider.value); });
    if (ticketInput) {
      ticketInput.addEventListener('input', function () {
        var v = parseFloat(ticketInput.value);
        if (!isNaN(v) && v > 0) { state.avgTicket = v; syncGroups(); }
      });
      ticketInput.addEventListener('change', function () {
        var v = parseFloat(ticketInput.value);
        if (isNaN(v) || v <= 0) v = DEFAULTS.avgTicket;
        state.avgTicket = Math.min(90, Math.max(8, v));
        sync();
      });
    }

    sync();
    renderStep();
    resetBooking();
    show('hero', true);
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-ysd-root]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.clReady) return;
    root.dataset.clReady = '1';
    root.classList.add('cl-js');

    // Reveal on scroll
    var reveals = root.querySelectorAll('.cl-reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

    // Video players
    root.querySelectorAll('[data-cl-player]').forEach(function (p) {
      var btn = p.querySelector('button.cl-player__poster');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var embed = btn.getAttribute('data-embed');
        if (embed) {
          var f = document.createElement('iframe');
          f.src = embed; f.allow = 'autoplay; fullscreen; picture-in-picture'; f.allowFullscreen = true;
          p.appendChild(f);
        } else {
          var v = p.querySelector('video');
          if (!v) return;
          v.muted = false; v.play();
        }
        p.classList.add('is-playing');
      });
    });

    function stopMedia(scope) {
      scope.querySelectorAll('video').forEach(function (v) { v.pause(); });
      scope.querySelectorAll('iframe').forEach(function (f) { f.remove(); });
      scope.querySelectorAll('.is-playing').forEach(function (p) { p.classList.remove('is-playing'); });
    }

    // Tabs (collab + tour)
    root.querySelectorAll('[data-cl-tabs]').forEach(function (group) {
      var tabs = group.querySelectorAll('[data-cl-tab]');
      var panels = group.querySelectorAll('[data-cl-panel]');
      var current = 0, timer = null;
      function show(i) {
        current = i;
        tabs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-selected', n === i); });
        panels.forEach(function (p, n) {
          if (n !== i) stopMedia(p);
          p.classList.toggle('is-active', n === i);
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-cl-tab'), 10)); restart(); });
      });
      function restart() {
        if (!group.hasAttribute('data-cl-tour') || root.dataset.autoplayTour !== 'true' || panels.length < 2) return;
        clearInterval(timer);
        timer = setInterval(function () { show((current + 1) % panels.length); }, 5000);
      }
      restart();
    });

    // Carousels
    root.querySelectorAll('[data-cl-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-cl-track]');
      c.querySelectorAll('[data-cl-scroll]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 20 : 320;
          track.scrollBy({ left: step * parseInt(b.getAttribute('data-cl-scroll'), 10), behavior: 'smooth' });
        });
      });
    });

    // Read more
    root.querySelectorAll('[data-cl-more]').forEach(function (b) {
      var q = b.parentElement.querySelector('[data-cl-quote]');
      var more = b.textContent, less = b.getAttribute('data-less');
      b.addEventListener('click', function () {
        var clamped = q.classList.toggle('is-clamped');
        b.textContent = clamped ? more : less;
      });
    });

    // Count-up
    var counters = root.querySelectorAll('[data-cl-count]');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var co = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          co.unobserve(e.target);
          var raw = e.target.getAttribute('data-cl-count');
          var m = raw.match(/^([^\d]*)([\d.,]+)(.*)$/);
          if (!m) return;
          var num = parseFloat(m[2].replace(/,/g, '.'));
          var decimals = (m[2].split(/[.,]/)[1] || '').length;
          var t0 = null, dur = 1600;
          function tick(ts) {
            if (!t0) t0 = ts;
            var k = Math.min((ts - t0) / dur, 1), ease = 1 - Math.pow(1 - k, 3);
            e.target.textContent = m[1] + (num * ease).toFixed(decimals) + m[3];
            if (k < 1) requestAnimationFrame(tick); else e.target.textContent = raw;
          }
          requestAnimationFrame(tick);
        });
      }, { threshold: .5 });
      counters.forEach(function (c) { co.observe(c); });
    }

    // Sticky bar
    var sticky = root.querySelector('[data-cl-sticky]');
    if (sticky) {
      var hero = root.querySelector('.cl-hero');
      var pricing = root.querySelector('[id^="cl-pricing-"]');
      var onScroll = function () {
        var y = window.scrollY;
        var afterHero = hero ? hero.getBoundingClientRect().bottom < 0 : y > 600;
        var atPricing = false;
        if (pricing) { var r = pricing.getBoundingClientRect(); atPricing = r.top < window.innerHeight && r.bottom > 0; }
        var on = afterHero && !atPricing;
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', !on);
        var link = sticky.querySelector('a'); if (link) link.tabIndex = on ? 0 : -1;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function initAll() { document.querySelectorAll('[data-cl-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-cl-root]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-sav"] && !Shopify.designMode) return;
  try {
    
class ShowcaseCarousel {
  constructor() {
    this.tabs = document.querySelectorAll('[data-tab]');
    this.slides = document.querySelectorAll('[data-slide]');
    this.prevBtn = document.querySelector('[data-prev]');
    this.nextBtn = document.querySelector('[data-next]');
    this.currentIndex = 0;
    
    this.init();
  }
  
  init() {
    this.prevBtn.addEventListener('click', () => this.navigate('prev'));
    this.nextBtn.addEventListener('click', () => this.navigate('next'));
  }
  
  navigate(direction) {
    this.tabs[this.currentIndex].classList.remove('active');
    this.slides[this.currentIndex].classList.remove('active');
    
    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % this.tabs.length;
    } else {
      this.currentIndex = (this.currentIndex - 1 + this.tabs.length) % this.tabs.length;
    }
    
    this.tabs[this.currentIndex].classList.add('active');
    this.slides[this.currentIndex].classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ShowcaseCarousel();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
